import React, { useEffect } from "react";
import { handleDownloadAppQRViewedEvent } from "../../../../utils/helperEventFunctions";
import { useRouter } from "next/router";
import CustomModal from "./CustomModal";
import useStore from "../../../../store/UseStore";

const AppDownloadQRModal = () => {
  const { openQRModal, setOpenQRModal } = useStore();
  const router = useRouter();

  useEffect(() => {
    if (openQRModal?.open) {
      handleDownloadAppQRViewedEvent({
        sourceScreen: router.pathname,
        sourceSection: openQRModal?.fromSection,
        status: "QR Opened",
      });
    }
  }, [openQRModal?.open]);

  return (
    <div className="hidden lg:block">
      {openQRModal?.open && (
        <CustomModal
          open={openQRModal?.open}
          handleCloseModal={() => {
            setOpenQRModal({ open: false, fromSection: "" });
            handleDownloadAppQRViewedEvent({
              sourceScreen: router.pathname,
              sourceSection: openQRModal?.fromSection,
              status: "QR Closed",
            });
          }}
          bgOpacity="bg-black/60"
          className="!bg-[#18181a] !rounded-3xl"
        >
          <div className="text-center text-white py-3">
            <h6 className="text-[28px] text-white">Download the Seekho App</h6>
            <p className="mt-3">Seekho Se Seekho</p>
            <img
              src="/assets/onelink-qr.png"
              alt="Seekho QR"
              className="w-[230px] mx-auto border p-2"
            />
            <p className="mt-3 font-light text-[13px] tracking-wide">
              Scan this code to download the App
            </p>
          </div>
        </CustomModal>
      )}
    </div>
  );
};

export default AppDownloadQRModal;
